/* eslint-disable class-methods-use-this */
/**
 * Mennegat Trading.
 *
 * @author Robuust
 * @author Bob Olde Hampsink <bob@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import * as Turbo from '@hotwired/turbo';

/**
 * Cart controller.
 */
export default class extends Controller {
  /**
   * Copy quote text.
   *
   * @param {Event} e
   */
  async copy(e) {
    const [copy, check] = e.target.children;
    await navigator.clipboard.writeText(e.params.quoteText);

    copy.classList.add('hidden');
    check.classList.remove('hidden');

    // Revert back after a delay
    setTimeout(() => {
      copy.classList.remove('hidden');
      check.classList.add('hidden');
    }, 2000);
  }

  /**
   * Complete cart.
   *
   * @param {Event} e
   */
  async complete(e) {
    const form = e.target;
    const action = form.querySelector('input[name="action"]');

    if (action.value === 'commerce/cart/update-cart') {
      e.preventDefault();

      Turbo.navigator.delegate.adapter.formSubmissionStarted(this);

      const response = await fetch(window.location.href, {
        method: 'POST',
        body: new FormData(form),
      });

      if (response.ok) {
        action.value = action.value.replace('update-cart', 'complete');
        form.requestSubmit();
      }
    }
  }
}
